import { supabase } from '@/lib/supabase/config';
import { getDeeplinkPrefix } from '@/shared/utils/deeplink-prefix';
import { handleError } from '@/shared/utils/error-handling';

interface CreatePortalSessionInput {
  organizationId: number;
}

interface CreatePortalSessionResponse {
  portalUrl: string;
}

export async function createPortalSession(
  input: CreatePortalSessionInput,
): Promise<CreatePortalSessionResponse> {
  const { data, error } = await supabase.functions.invoke(
    'create-portal-session',
    {
      body: { ...input, deeplink: getDeeplinkPrefix() },
    },
  );

  if (error) {
    const appError = await handleError(error);
    throw appError;
  }

  return data;
}
